import { useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const [copied, setCopied] = useState(false);

  const handleBookmark = () => {
    const url = "http://msldyun.cn/";
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section className="relative min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Night%20red%20carpet%20event%20with%20warm%20golden%20spotlights%20dramatic%20atmosphere%20paparazzi%20flash%20photography%2C%20glamorous%20celebrity%20nightlife%20scene%20with%20dark%20moody%20background%20and%20warm%20amber%20tones%2C%20editorial%20fashion%20photography%20cinematic%20grain%20texture&width=1600&height=900&seq=cta-bg-01&orientation=landscape"
        alt="91EatGossip 收藏我们"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-foreground-900/60" />

      <div className="relative z-10 text-center px-4 md:px-8 max-w-2xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-wider mb-4 md:mb-6">
          永不迷路
        </h2>
        <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8">
          收藏91EatGossip最新地址发布页，第一时间获取吃瓜入口。
          <br className="hidden md:block" />
          每次地址变更，我们都会在这里同步更新。
        </p>
        <button
          onClick={handleBookmark}
          className="inline-flex items-center gap-0 bg-foreground-950 text-white rounded-full pr-6 pl-0 py-0 text-sm font-medium uppercase tracking-wide hover:bg-foreground-800 transition-colors overflow-hidden"
        >
          <span className="w-12 h-12 bg-accent-500 flex items-center justify-center shrink-0">
            <i className="ri-bookmark-line text-white" />
          </span>
          <span className="px-4 whitespace-nowrap">
            {copied ? "已复制链接" : "收藏本页"}
          </span>
          <i className="ri-arrow-right-up-line ml-1" />
        </button>
      </div>
    </section>
  );
}
